export default class WellKnownRoles {
    static LimeAdmin: string = 'admin';
    static OrganisationMemberManager: string = 'Organisation Member Manager';
    static OrganisationBillingViewer: string = 'Organisation Billing Viewer';
    static OrganisationBillingManager: string = 'Organisation Billing Manager';
    static OrganisationUserAdmin: string = 'Organisation User Administrator';
}